import React from "react";
import { Card, Button } from "antd";
import styled from "styled-components";

const Layout = styled.div`
  font-family: "Oswald" sans-serif;
  background: #f6f6f6;
  .card-wrap {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    justify-content: center;
    padding: 30px 15%;
    grid-gap: 30px;
    @media (max-width: 767px) {
      grid-template-columns: 1fr;
      padding: 30px 5%;
      justify-content: center;
    }
    @media (width: 768px) {
      grid-template-columns: repeat(2, 1fr);
      padding: 30px 5%;
    }
  }
  .card-style {
    width: 100%;
    height: 377px;
    margin: 30px 0 0 0;
  }
  .img-style {
    width: 100%;
    object-fit: cover;
    height: 260px;
  }
`;

const { Meta } = Card;

const gifts = [
  {
    id: 1,
    imgUrl: "/images/lappy.jpg",
    title: "MACBOOK PRO",
    price: "#500000",
  },
  {
    id: 2,
    imgUrl: "/images/bed.jpeg",
    title: "MATTRESS",
    price: "#500000",
  },
  {
    id: 3,
    imgUrl: "images/iphone.jpeg",
    title: "IPHONE 13PRO MAX",
    price: "#500000",
  },
];
function CardCarousel() {
  return (
    <>
      <Layout>
        <div className="card-wrap">
          {gifts &&
            gifts.map((gift) => (
              <div key={gift.id}>
                <Card
                  hoverable
                  className="grow card-style"
                  cover={
                    <img
                      alt="example"
                      src={gift.imgUrl}
                      className="img-style"
                    />
                  }
                >
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div>
                      <Meta title={gift.title} />
                      <div style={{ margin: 7 }}>
                        <p>
                          <b>{gift.price}</b>
                        </p>
                      </div>
                    </div>
                    <Button type="primary">Buy</Button>
                  </div>
                </Card>
              </div>
            ))}
        </div>
      </Layout>
    </>
  );
}

export default CardCarousel;
